import React, { useEffect, useState, useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import TitleButtons from "../../../../../components/TitleButtons";
import TextField from "../../../../../components/TextField";
import DropField from "../../../../../components/DropField";
import Button from "../../../../../components/Button";

const API_GET_URL =
  "https://api.eva-googlemarine.com/departamentos/suprimentos/produtos";
const API_EDIT_URL = "https://api.eva-googlemarine.com/geral/produtos-editar";

// ===== Tipos =====
type ApiProduto = {
  id: number;
  codigo: string;
  ncm: string | null;
  nome: string | null;
  classificacao: string | null;
  posicao: string | null;
  vendavel: boolean | null;
  responsavel_registro: number | null;
  departamento: string;
  criado_em: string;
  atualizado_em: string;
  dimensao?: string | null;
  peso?: string | null;
  ocultar?: boolean | null;
  empresa_id?: number | null;
};

type ApiResponse = {
  ok: boolean;
  data?: {
    produto: ApiProduto;
  };
  erro?: string;
};

const opcoesPosicao = [
  { value: "A1", label: "A1" },
  { value: "A2", label: "A2" },
  { value: "A3", label: "A3" },
  { value: "A4", label: "A4" },
  { value: "A5", label: "A5" },
  { value: "A6", label: "A6" },
  { value: "B1", label: "B1" },
  { value: "B2", label: "B2" },
  { value: "B3", label: "B3" },
  { value: "B4", label: "B4" },
  { value: "B5", label: "B5" },
  { value: "B6", label: "B6" },
  { value: "C1", label: "C1" },
  { value: "C2", label: "C2" },
  { value: "C3", label: "C3" },
  { value: "C4", label: "C4" },
  { value: "C5", label: "C5" },
  { value: "C6", label: "C6" },
  { value: "D1", label: "D1" },
  { value: "D2", label: "D2" },
  { value: "D3", label: "D3" },
  { value: "D4", label: "D4" },
  { value: "D5", label: "D5" },
  { value: "D6", label: "D6" },
  { value: "E1", label: "E1" },
  { value: "E2", label: "E2" },
  { value: "E3", label: "E3" },
  { value: "E4", label: "E4" },
  { value: "E5", label: "E5" },
  { value: "E6", label: "E6" },
  { value: "F1", label: "F1" },
  { value: "F2", label: "F2" },
  { value: "F3", label: "F3" },
  { value: "F4", label: "F4" },
  { value: "F5", label: "F5" },
  { value: "F6", label: "F6" },
  { value: "G1", label: "G1" },
  { value: "G2", label: "G2" },
  { value: "G3", label: "G3" },
  { value: "G4", label: "G4" },
  { value: "G5", label: "G5" },
  { value: "G6", label: "G6" },
  { value: "H1", label: "H1" },
  { value: "H2", label: "H2" },
  { value: "H3", label: "H3" },
  { value: "H4", label: "H4" },
  { value: "H5", label: "H5" },
  { value: "H6", label: "H6" },
  { value: "I1", label: "I1" },
  { value: "I2", label: "I2" },
  { value: "I3", label: "I3" },
  { value: "I4", label: "I4" },
  { value: "I5", label: "I5" },
  { value: "I6", label: "I6" },
  { value: "J1", label: "J1" },
  { value: "J2", label: "J2" },
  { value: "J3", label: "J3" },
  { value: "J4", label: "J4" },
  { value: "J5", label: "J5" },
  { value: "J6", label: "J6" },
  { value: "CENTRAL 1", label: "CENTRAL 1" },
  { value: "CENTRAL 2", label: "CENTRAL 2" },
  { value: "CENTRAL 3", label: "CENTRAL 3" },
  { value: "CENTRAL 4", label: "CENTRAL 4" },
  { value: "CENTRAL 5", label: "CENTRAL 5" },
  { value: "CENTRAL 6", label: "CENTRAL 6" },
  { value: "CENTRAL 7", label: "CENTRAL 7" },
  { value: "CENTRAL 8", label: "CENTRAL 8" },
];

const opcoesClassificacao = [
  { value: "ESTOQUE", label: "ESTOQUE" },
  { value: "CONSUMO", label: "CONSUMO" },
  { value: "RH", label: "RH" },
  { value: "VENDA", label: "VENDA" },
];

const opcoesBoolean = [
  { value: "true", label: "Sim" },
  { value: "false", label: "Não" },
];

const NoticeBanner: React.FC<{
  notice: { type: "success" | "error" | "notify"; text: string };
  onClose?: () => void;
}> = ({ notice, onClose }) => {
  let bg, color, border;
  switch (notice.type) {
    case "success":
      bg = "#e6ffed";
      color = "#0f5132";
      border = "#badbcc";
      break;
    case "error":
      bg = "#ffecec";
      color = "#842029";
      border = "#f5c2c7";
      break;
    case "notify":
    default:
      bg = "#e7f1ff";
      color = "#084298";
      border = "#b6d4fe";
      break;
  }

  return (
    <div
      role="alert"
      style={{
        margin: "12px 40px 0 40px",
        padding: "10px 12px",
        borderRadius: 8,
        background: bg,
        color: color,
        border: `1px solid ${border}`,
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ flex: 1 }}>{notice.text}</span>
        {onClose && (
          <button
            type="button"
            aria-label="Fechar aviso"
            onClick={onClose}
            style={{
              background: "transparent",
              border: "none",
              color: "inherit",
              fontSize: 16,
              cursor: "pointer",
            }}
          >
            ×
          </button>
        )}
      </div>
    </div>
  );
};

const EditarProduto: React.FC = () => {
  const { codigo: codigoParam } = useParams<{ codigo: string }>();
  const codigoFromUrl = useMemo(
    () => decodeURIComponent(codigoParam ?? ""),
    [codigoParam]
  );

  const navigate = useNavigate();

  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [notice, setNotice] = useState<null | {
    type: "success" | "error" | "notify";
    text: string;
  }>(null);

  const [produtoId, setProdutoId] = useState<number | null>(null);
  const [original, setOriginal] = useState<ApiProduto | null>(null);

  // Campos editáveis
  const [codigo, setCodigo] = useState("");
  const [ncm, setNcm] = useState("");
  const [nome, setNome] = useState("");
  const [classificacao, setClassificacao] = useState("");
  const [posicao, setPosicao] = useState("");
  const [dimensao, setDimensao] = useState("");
  const [peso, setPeso] = useState("");
  const [vendavel, setVendavel] = useState<boolean | null>(null);
  const [ocultar, setOcultar] = useState<boolean | null>(null);

  // Carregar dados do produto pelo código
  useEffect(() => {
    if (!codigoFromUrl) {
      setNotice({
        type: "error",
        text: "Código do produto inválido na URL.",
      });
      setLoading(false);
      return;
    }

    let disposed = false;

    (async () => {
      setLoading(true);
      setNotice(null);
      try {
        const res = await fetch(
          `${API_GET_URL}/${encodeURIComponent(codigoFromUrl)}`,
          {
            method: "GET",
            headers: { Accept: "application/json" },
          }
        );

        const json: ApiResponse = await res
          .json()
          .catch(() => ({ ok: false } as ApiResponse));

        if (!res.ok || !json.ok || !json.data?.produto) {
          const msg =
            json.erro ||
            `Falha ao carregar produto (HTTP ${res.status}). Verifique o código.`;
          if (!disposed) {
            setNotice({ type: "error", text: msg });
            setLoading(false);
          }
          return;
        }

        const p = json.data.produto;

        if (!disposed) {
          setProdutoId(p.id);
          setOriginal(p);

          setCodigo(p.codigo ?? "");
          setNcm(p.ncm ?? "");
          setNome(p.nome ?? "");
          setClassificacao((p.classificacao ?? "").toUpperCase());
          setPosicao(p.posicao ?? "");
          setDimensao(p.dimensao ?? "");
          setPeso(p.peso ?? "");
          setVendavel(p.vendavel ?? null);
          setOcultar(p.ocultar ?? null);

          setNotice({
            type: "notify",
            text: `Editando produto ID ${p.id} (código: ${p.codigo}).`,
          });
          setLoading(false);
        }
      } catch (e: any) {
        if (!disposed) {
          setNotice({
            type: "error",
            text:
              e?.message ||
              "Erro ao carregar dados do produto. Tente novamente.",
          });
          setLoading(false);
        }
      }
    })();

    return () => {
      disposed = true;
    };
  }, [codigoFromUrl]);

  async function handleSave() {
    if (!produtoId || !original) {
      setNotice({
        type: "error",
        text: "Produto não carregado. Recarregue a página.",
      });
      return;
    }

    setNotice(null);

    // Montar diffs: só envia se mudou
    const updates: any = {};

    const normStr = (v: unknown) => (v == null ? "" : String(v));

    if (
      normStr(codigo).toUpperCase() !== normStr(original.codigo).toUpperCase()
    ) {
      if (!codigo.trim()) {
        setNotice({
          type: "error",
          text: "Código do produto não pode ficar vazio.",
        });
        return;
      }
      updates.codigo = codigo.trim().toUpperCase();
    }

    if (normStr(nome) !== normStr(original.nome)) {
      if (!nome.trim()) {
        setNotice({
          type: "error",
          text: "Nome do produto não pode ficar vazio.",
        });
        return;
      }
      updates.nome = nome.trim();
    }

    if (normStr(ncm) !== normStr(original.ncm)) {
      updates.ncm = ncm.trim() || null;
    }

    if (
      normStr(classificacao).toUpperCase() !==
      normStr(original.classificacao).toUpperCase()
    ) {
      updates.classificacao = classificacao.trim().toUpperCase() || null;
    }

    if (normStr(posicao) !== normStr(original.posicao)) {
      updates.posicao = posicao.trim() || null;
    }

    if (normStr(dimensao) !== normStr(original.dimensao)) {
      updates.dimensao = dimensao.trim() || null;
    }

    if (normStr(peso) !== normStr(original.peso)) {
      // backend já faz parseDecimalString
      updates.peso = peso.trim() || null;
    }

    if (vendavel !== original.vendavel) {
      if (vendavel !== null) updates.vendavel = vendavel;
    }

    if (ocultar !== original.ocultar) {
      if (ocultar !== null) updates.ocultar = ocultar;
    }

    if (Object.keys(updates).length === 0) {
      setNotice({
        type: "notify",
        text: "Nenhuma alteração detectada para salvar.",
      });
      return;
    }

    const body = {
      id: produtoId,
      ...updates,
    };

    setSubmitting(true);
    try {
      const res = await fetch(API_EDIT_URL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(body),
      });

      const txt = await res.text().catch(() => "");
      let json: any = null;
      try {
        json = txt ? JSON.parse(txt) : null;
      } catch {
        json = null;
      }

      if (!res.ok || json?.ok === false) {
        const backendMsg =
          json?.erro ||
          (Array.isArray(json?.erros) && json.erros.join(" | ")) ||
          `Falha ao salvar (HTTP ${res.status})`;
        setNotice({ type: "error", text: backendMsg });
        return;
      }

      setNotice({
        type: "success",
        text: "Dados do produto atualizados com sucesso.",
      });

      // Atualiza "original" com o que foi salvo
      setOriginal((prev) =>
        prev
          ? ({
              ...prev,
              ...updates,
            } as ApiProduto)
          : prev
      );
    } catch (e: any) {
      setNotice({
        type: "error",
        text: e?.message || "Erro de rede ao salvar alterações.",
      });
    } finally {
      setSubmitting(false);
    }
  }

  const vendavelValue = vendavel === null ? "" : vendavel ? "true" : "false";
  const ocultarValue = ocultar === null ? "" : ocultar ? "true" : "false";

  return (
    <div>
      <TitleButtons
        title={`Suprimentos - Editar Produto / ${codigoFromUrl}`}
        buttons={[
          {
            label: "Voltar para detalhes",
            onClick: () =>
              navigate(
                `/suprimentos/produtos/${encodeURIComponent(codigoFromUrl)}`
              ),
            variant: "secondary",
          },
          {
            label: submitting ? "Salvando..." : "Salvar alterações",
            onClick: handleSave,
            variant: "primary",
          },
        ]}
        buttonMarginRight="40px"
      />

      {notice && (
        <NoticeBanner notice={notice} onClose={() => setNotice(null)} />
      )}

      {loading ? (
        <div
          style={{
            padding: "40px",
            fontFamily: "Inter, sans-serif",
            fontSize: 14,
            opacity: 0.7,
          }}
        >
          Carregando dados do produto…
        </div>
      ) : (
        <div style={{ padding: "40px" }}>
          <TextField
            label="Código do Produto"
            value={codigo}
            onChange={setCodigo}
            placeholder="Digite o código do produto"
            uppercase={true}
          />

          <TextField
            label="Nome do Produto"
            value={nome}
            onChange={setNome}
            placeholder="Digite o nome do produto"
            uppercase={true}
          />

          <TextField
            label="NCM"
            value={ncm}
            onChange={setNcm}
            placeholder="Digite aqui o NCM do Produto"
          />

          <TextField
            label="Dimensões"
            value={dimensao}
            onChange={setDimensao}
            placeholder="Ex.: 10x20x30cm"
          />

          <TextField
            label="Peso"
            value={peso}
            onChange={setPeso}
            placeholder="Ex.: 1,25 kg ou 1250 g"
          />

          <DropField
            label="Classificação"
            value={classificacao}
            onChange={(v) => setClassificacao(v ?? "")}
            options={opcoesClassificacao}
            placeholder="Selecione..."
            uppercase
          />

          <DropField
            label="Posição no Estoque"
            value={posicao}
            onChange={(v) => setPosicao(v ?? "")}
            options={opcoesPosicao}
            placeholder="Selecione..."
            uppercase
          />

          <DropField
            label="Vendável"
            value={vendavelValue}
            onChange={(v) => {
              if (!v) setVendavel(null);
              else setVendavel(v === "true");
            }}
            options={opcoesBoolean}
            placeholder="Selecione..."
          />

          <DropField
            label="Oculto"
            value={ocultarValue}
            onChange={(v) => {
              if (!v) setOcultar(null);
              else setOcultar(v === "true");
            }}
            options={opcoesBoolean}
            placeholder="Selecione..."
          />

          <div style={{ marginTop: 24 }}>
            <Button
              text={submitting ? "Salvando..." : "Salvar alterações"}
              onClick={handleSave}
              disabled={submitting || !produtoId}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default EditarProduto;
